module.exports = __webpack_public_path__ + "static/img/kuaisubanli.bef5889.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serviceCenter/kuaisubanli.png
// module id = +YdD
// module chunks = 44